import { render, staticRenderFns } from "./EmployerAddress.vue?vue&type=template&id=b5d847a0&scoped=true"
import script from "./EmployerAddress.vue?vue&type=script&lang=ts"
export * from "./EmployerAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d847a0",
  null
  
)

export default component.exports